import { ListWithTotals, PostDto, PostFilter } from '@sweatpals/shared';
import { AxiosInstance } from 'axios';
import { PostsService as BasePostsService } from '@sweatpals/data-services';

export class PostsService {
	private readonly baseService: BasePostsService;

	constructor(httpClient: AxiosInstance) {
		this.baseService = new BasePostsService(httpClient);
	}

	public async findAll(filter: PostFilter): Promise<ListWithTotals<PostDto>> {
		const { data } = await this.baseService.findAll(filter);
		return data;
	}

	public async findByAlias(alias: string): Promise<PostDto> {
		const { data } = await this.baseService.findByAlias(alias);
		return data;
	}
}
